import React, { useEffect, useState } from 'react';
import { Modal, Table, Spin, Typography } from 'antd';
import { fetchExamScoreDetail } from '../../services/reportService';

interface ScoreDetailRow {
  TieuChiID: string;
  TenTieuChi: string;
  DiemToiDa: number;
  DiemThucTe: number | null;
}

interface ScoreDetailData {
  MaHS?: string;
  Hoten?: string;
  TenKyThi?: string;
  TenMonHoc?: string;
  NguoiCham?: string;
  chiTiet?: ScoreDetailRow[];
}

interface ScoreDetailModalProps {
  open: boolean;
  onClose: () => void;
  row: any;
}

const ScoreDetailModal: React.FC<ScoreDetailModalProps> = ({ open, onClose, row }) => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<ScoreDetailData>({});

  useEffect(() => {
    if (!open || !row) return;
    setLoading(true);
    fetchExamScoreDetail(row.MaHS, row.ExamSessionID, row.NguoiCham)
      .then((res: ScoreDetailData) => setData(res))
      .catch(() => setData({}))
      .finally(() => setLoading(false));
  }, [open, row]);

  return (
    <Modal open={open} onCancel={onClose} onOk={onClose} title={`Chi tiết điểm sinh viên${data.NguoiCham ? ` - Người chấm: ${data.NguoiCham}` : ''}`} width={700} footer={null}>
      <Spin spinning={loading}>
        {data ? (
          <>
            <Typography.Paragraph>
              <b>Mã SV:</b> {data.MaHS || ''} &nbsp; <b>Họ tên:</b> {data.Hoten || ''} <br/>
              <b>Kỳ thi:</b> {data.TenKyThi || ''} &nbsp; <b>Môn học:</b> {data.TenMonHoc || ''}
              {data.NguoiCham && (
                <div style={{marginTop: 4}}><b>Người chấm:</b> {data.NguoiCham}</div>
              )}
            </Typography.Paragraph>
            <Table
              dataSource={data.chiTiet || []}
              columns={[
                { title: 'Tiêu chí', dataIndex: 'TenTieuChi', key: 'TenTieuChi' },
                { title: 'Điểm tối đa', dataIndex: 'DiemToiDa', key: 'DiemToiDa' },
                { title: 'Điểm thực tế', dataIndex: 'DiemThucTe', key: 'DiemThucTe', render: (v: any) => v === null ? <span style={{color:'#aaa'}}>Chưa nhập</span> : v }
              ]}
              pagination={false}
              rowKey={(record: ScoreDetailRow, index) => record && record.TieuChiID ? record.TieuChiID : `tieu-chi-${index}`}
              bordered
              size="small"
            />
          </>
        ) : (
          <Typography.Text type="danger">Không có dữ liệu hoặc mã sinh viên/kỳ thi không hợp lệ.</Typography.Text>
        )}
      </Spin>
    </Modal>
  );
};

export default ScoreDetailModal; 